import React from 'react';
import { FileText, Info, Shield, LayoutDashboard } from 'lucide-react';
export function SEONavigationSection() {
  const links = [{
    to: '/about',
    label: 'About ToxicDetector',
    description: 'Learn about our mission and forensic AI technology.',
    icon: <Info className="w-5 h-5" data-id="element-2947" />
  }, {
    to: '/dashboard',
    label: 'User Dashboard',
    description: 'Access your scan history and toxicity reports.',
    icon: <LayoutDashboard className="w-5 h-5" data-id="element-2948" />
  }, {
    to: '/privacy',
    label: 'Privacy Policy',
    description: 'How we protect your data with AES-256 encryption.',
    icon: <Shield className="w-5 h-5" data-id="element-2949" />
  }, {
    to: '/terms',
    label: 'Terms of Service',
    description: 'Usage guidelines and legal disclosures.',
    icon: <FileText className="w-5 h-5" data-id="element-2950" />
  }, {
    to: '/blog',
    label: 'Blog & Resources',
    description: 'Articles on gaslighting, narcissism, and toxic patterns.',
    icon: <FileText className="w-5 h-5" data-id="element-2951" />
  }];
  return <section className="py-16 bg-[#050505] border-t border-gray-900" data-id="element-2952">
      <div className="max-w-6xl mx-auto px-6" data-id="element-2953">
        <div className="mb-8" data-id="element-2954">
          <h2 className="text-2xl font-bold text-white uppercase tracking-wide mb-2" data-id="element-2955">
            Quick Links
          </h2>
          <p className="text-gray-500 font-mono text-sm" data-id="element-2956">
            Navigate our platform and resources.
          </p>
        </div>

        <nav aria-label="Secondary navigation" data-id="element-2957">
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2958">
            {links.map((link, index) => <li key={index} data-id="element-2959">
                <a href={link.to} className="flex items-start gap-4 p-4 rounded-lg border border-gray-800 bg-[#0A0A0A] hover:border-gray-600 hover:bg-gray-900/50 transition-all group" data-id="element-2960">
                  <div className="mt-1 text-gray-500 group-hover:text-[#FF0000] transition-colors" data-id="element-2961">
                    {link.icon}
                  </div>
                  <div data-id="element-2962">
                    <span className="block text-white font-bold text-sm uppercase tracking-wide mb-1 group-hover:text-[#FF0000] transition-colors" data-id="element-2963">
                      {link.label}
                    </span>
                    <span className="block text-gray-500 font-mono text-xs" data-id="element-2964">
                      {link.description}
                    </span>
                  </div>
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </section>;
}